import { wishListReducer } from '../../wishList/reducers/WishListReducer';
import wishListSaga from '../../wishList/sagas/WishListSaga';
const loadWishListModule = () => ({
    id: 'WishList',
    reducerMap: {
        wishList: wishListReducer,
    },
    sagas: [wishListSaga],
});
export default loadWishListModule;
